<template>
  <div>
    <Chart :cdata="config" />
  </div>
</template>

<script>
import Chart from "./chart.vue";
export default {
  props: {
    cdata: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  watch: {
    cdata(newVal) {
      this.setData(newVal);
    },
  },
  data() {
    return {
      config: {},
    };
  },
  components: {
    Chart,
  },
  mounted() {
    // this.setData();
  },
  methods: {
    // 根据自己的业务情况修改
    setData(data) {
      let category = [];
      let series1 = [];
      let series2 = [];
      for (let item in data) {
        category.push(item);
        series1.push(data[item][0]);
        series2.push(data[item][1]);
      }
      this.config = {
        category,
        series1,
        series2,
      };
    },
  },
};
</script>

<style lang="scss" scoped></style>
